module.exports = __webpack_public_path__ + "img/img_level_4.e465125d.png";